import { NewbuildingKpnBannerContext, KpnBanner } from '@cian/frontend-newbuilding-kpn-banners';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { EBannerType } from 'shared/constants/banner';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { selectNewbuildingSuburbanTrapGroup } from 'shared/selectors/abExperiments';
import { getUserId, selectDefaultPhoneNumber } from 'shared/selectors/callbackRightNow';
import { regionIdSelector } from 'shared/selectors/offerData/geo/regionIdSelector';
import { selectTrackingUrl } from 'shared/selectors/offerData/selectTrackingUrl';
import { selectNewbuildingSuburbanTrapUrl } from 'shared/selectors/selectNewbuildingSuburbanTrapUrl';
import { getPrivacyPolicyUrl } from 'shared/utils/newbuildingRentBanner/getPrivacyPolicyUrl';

interface INewbuildingSuburbanBannerContainerProps {
  bannerType: EBannerType.SuburbanListing | EBannerType.SuburbanKpnCallback;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const NewbuildingSuburbanBannerContainer = (props: INewbuildingSuburbanBannerContainerProps) => {
  const context = useApplicationContext();

  const regionId = useSelector(regionIdSelector);
  const rentTrapUrl = useSelector(selectNewbuildingSuburbanTrapUrl);
  const defaultPhoneNumber = useSelector(selectDefaultPhoneNumber);
  const gaLabel = useSelector(selectTrackingUrl);
  const userId = useSelector(getUserId);
  const suburbanTrapGroup = useSelector(selectNewbuildingSuburbanTrapGroup);

  const personalAgreementLink = React.useMemo(() => {
    return getPrivacyPolicyUrl(context.config);
  }, [context]);

  /* istanbul ignore next */
  const banner = suburbanTrapGroup === 'B' ? 'suburban_sale_link' : 'suburban_sale_callback';

  /* istanbul ignore next */
  if (!rentTrapUrl) {
    return null;
  }

  return (
    <div data-testid="NewbuildingRentBannerContainer">
      <NewbuildingKpnBannerContext.Provider value={context}>
        <KpnBanner
          placeType="card"
          personalAgreementLink={personalAgreementLink}
          regionId={regionId}
          newobjectsListingUrl={rentTrapUrl}
          bannerType={banner}
          defaultPhoneNumber={defaultPhoneNumber}
          gaLabel={gaLabel}
          userId={userId}
        />
      </NewbuildingKpnBannerContext.Provider>
    </div>
  );
};
